module.exports = __webpack_public_path__ + "media/images/front/treatment_support/img_modal-907cc9cd8fec648ae6919bc432100ad7.png";